import { FormControl } from "@angular/forms";
import { DrugScheduleEnum } from "../interfaces/DrugScheduleEnum ";

export function CSOSRequiredValidator(dataArray: any[], control: FormControl): any {
    if (dataArray?.length && dataArray?.some(x => x?.schedule === DrugScheduleEnum.C2) && !control.value) {
    return { required: true };
    }
    return null;
  }